<template>
  <div v-if="texts" class="text-wrapper fill-height layout column py-2">
    <div v-if="isLoading" class="loading layout fill-height column align-center justify-center">
      <v-progress-circular color="primary" indeterminate />
    </div>
    <div v-if="texts && texts.length === 0" class="align-center empty pa-3">
      <div class="justify-center layout">
        No Texts available. Try to synchronise.
      </div>
      <div class="justify-center layout">
        <v-btn :loading="isLoading" icon color="primary" @click.stop="$store.dispatch('slides/extractText')">
          <v-icon>{{ icons.sync }}</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-show="!isLoading" class="content-wrapper">
      <div v-if="texts && texts.length > 0" class="typo-wrapper">
        <div v-for="textgroup in texts" :key="textgroup._id" class="group">
          <div v-for="table in textgroup.tables" :key="table._id">
            <div v-for="cell in table.tableCells" :key="cell._id">
              <div
                v-for="text in filterText(cell.textStyleRanges)"
                :key="text._id"
                class="type-handler nowrap pa-1"
                @mouseleave.stop="$store.commit('slides/setTextActive', {})"
                @mouseenter.stop="$store.commit('slides/setTextActive', text)"
              >
                <textarea-autosize
                  v-model="text.text"
                  :min-height="30"
                  rows="1"
                  spellcheck="false"
                  class="text pa-2"
                />
              </div>
            </div>
          </div>
          <span
            v-for="story in filterText(textgroup.textStyleRanges)"
            :key="story._id"
            class="type-handler layout nowrap pa-1"
            @mouseleave.stop="$store.commit('slides/setTextActive', {})"
            @mouseenter.stop="$store.commit('slides/setTextActive', story)"
          >
            <textarea-autosize
              v-model="story.text"
              spellcheck="false"
              :min-height="30"
              rows="1"
              :disabled="!story.isEditable"
              class="text pa-2"
            />
            <!-- <div class="meta bordered ml-1 pa-2">
              <div>{{ (story.isEditable) ? 'Editable' : 'Not Editable' }}</div>
              <div class="layout justify-center">
                <v-icon>{{ (story.textPosition === 'normal') ? icons.format.normal: (story.textPosition === 'subScript') ? icons.format.lowercase: icons.format.uppercase }}</v-icon>
              </div>
            </div> -->
          </span>
        </div>
      </div>
      <div v-if="texts && texts.length > 0" class="sync-button mt-4">
        <v-btn :loading="isLoading" block depressed color="primary" @click.prevent="save">
          Sync Text to File
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import icons from '../../../mixins/icons';
import CoreInputVue from '../../core/inputs/CoreInput.vue';
export default {
  name: 'TextComponent',
  components: {
    coreInput: CoreInputVue
  },
  mixins: [icons],
  data() {
    return {
      isLoading: false
    };
  },
  mounted() {
    this.extractText(this.$route.query.asset);
  },
  computed: {
    ...mapState('slides', {
      texts: state => state.active.asset.text,
      slide: state => state.active
    })
  },
  methods: {
    filterText(l) {
      return l.filter(i => {
        return i.text !== ' ';
      });
    },
    extractText(id) {
      this.isLoading = true;
      return this.$store
        .dispatch('slides/extractText', id)
        .then(_ => (this.isLoading = false))
        .catch(_ => {
          this.isLoading = false;
          this.$store.dispatch('alerts/warning', 'Not able to get texts. Please try again.');
        });
    },
    checkChanges(e) {},
    save() {
      this.isLoading = true;
      this.$store
        .dispatch('slides/replaceText', { text: this.texts })
        .then(() => {
          this.extractText();
        })
        .catch(() => {
          this.isLoading = false;
          this.$store.dispatch('alerts/warning', 'Not able to replace text. Please try again.');
          this.extractText();
        });
    }
  }
};
</script>

<style scoped>
.bordered {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}
.sync-button {
  width: 100%;
  position: sticky;
  bottom: 10px;
}
.meta {
  /* background-color: rgba(0,0,0,.12); */
  color: grey;
  font-size: 0.9em;
  text-align: center;
}
.text {
  width: 100%;
  outline: none;
  text-align: left;
  border-radius: 2px;
}
.text:focus {
  border: 1px solid var(--new-blue);
  background-color: white;
}
.content-wrapper {
  padding-left: 20px;
  padding-right: 20px;
}
.group {
  border-radius: 16px;
  margin-bottom: 4px;
  background-color: #f5f5f5;
}
</style>
